import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Error } from 'fl-foundation';
import { AuthorizationData } from 'fl-platform-authorizer';
import { isTokenExpired } from 'qp-utility';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { ConfigService } from '../services/config/config.service';
import { PlaybackService } from '../services/playback/playback.service';
import { QPATService } from '../services/qpat/qpat.service';
import { hasSelectedProfile } from '../utils/LoginUtils';
import { includeAuthHeader } from '../utils/tokenUtils';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private qpatService: QPATService,
    private configService: ConfigService,
    private playbackService: PlaybackService,
    private localStorage: LocalStorageService
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //dont intercept auth0 url
    const isAuth0Url = request.url.includes(this.configService.applicationConfig.auth0Url);
    //dont intercept qpatUrl url
    const isQpatUrl = request.url === this.configService.applicationConfig.qpatURL;
    // auth0 token validation
    if (!isAuth0Url && !isQpatUrl) {
      //x auth token
      if (hasSelectedProfile(this.localStorage) && isTokenExpired(this.localStorage.getItem(LocalStorageKeys.XAUTH_TOKEN_EXP))) {
        return this.updateXAuthToken().pipe(
          switchMap(() => {
            return next.handle(request);
          })
        );
      }
      // auth data token
      if (
        includeAuthHeader(request, this.configService.applicationConfig) &&
        isTokenExpired(this.localStorage.getItem(LocalStorageKeys.AUTHDATA_TOKEN_EXP))
      ) {
        return this.updateAuthdataToken().pipe(
          switchMap(() => {
            return next.handle(request);
          })
        );
      }
    }
    return next.handle(request).pipe(
      catchError((error) => {
        if (error?.code === '41960901') {
          // "Invalid X-Session-Authorization"
          // force the refresh
          this.localStorage.removeItem(LocalStorageKeys.REFRESH_TOKEN_EXP);
        }
        return throwError(error);
      })
    );
  }

  updateXAuthToken(): Observable<void> {
    return from(this.qpatService.refreshXAuthToken());
  }

  updateAuthdataToken(): Observable<AuthorizationData | Error> {
    return from(this.playbackService.ensureAuthorization());
  }
}
